const PagedList = require('../entities/paged-list');

const Region = require('../entities/region');

const LegacyRegionsRepo = require('./regions-legacy-repo');

const {
  strinct,
  geoShape
} = require('../utils/serialize');

const detailFields = ['id', 'country', 'county', 'state', 'city', 'neighbourhood', 'locality'];
const detailFieldsWithArea = ['id', 'country', 'county', 'state', 'city', 'neighbourhood', 'locality', 'area'];
const searchFields = ['id', 'country', 'county', 'state', 'city', 'neighbourhood', 'locality'];
const createFields = ['id', 'country', 'county', 'state', 'city', 'neighbourhood', 'locality', 'area'];

const serialize = region => ({
  osmId: strinct(region.osmId),
  googlePlaceId: strinct(region.googlePlaceId),
  locality: strinct(region.locality),
  neighbourhood: strinct(region.neighbourhood),
  city: region.city,
  // required
  county: strinct(region.county),
  state: strinct(region.state),
  // required
  region: strinct(region.region),
  country: strinct(region.country),
  // required
  area: geoShape(region.area)
});

class RegionRepo {
  constructor(client, id) {
    this.client = client;
    this.id = id;
  }

  details({
    /*: {
        includeArea: boolean
      }*/

    includeArea = false
  } = {})
  /*: Promise<Region>*/
  {
    const req = new this.client.Request(`/regions/${this.id}`, undefined, includeArea ? detailFieldsWithArea : detailFields);

    req.parse = json => {
      const region = new Region(json); // Being `complete` is a prerequisite for being persisted (ie: having an id at all)

      region.isComplete = true;
      return region;
    };

    return this.client.get(req);
  }

}

class RegionsRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;

    this.for = (id
    /*: addressId*/
    ) => new RegionRepo(client, id);

    this.legacy = new LegacyRegionsRepo(this.client);
  }

  search({
    /*: {
        query: string
      }*/

    query
  } = {})
  /*: Promise<PagedList<Region>>*/
  {
    const params = {
      q: query
    };
    const path = '/regions/search';
    const req = new this.client.Request(path, params, searchFields);
    req.parse = Region.fromJsonSimple;
    return this.client.get(req);
  }

  multiDetails(regionIds
  /*: Array<string>*/
  , {
    /*: { includeArea: boolean }*/

    includeArea = false
  } = {})
  /*: Promise<PagedList<Region>>*/
  {
    const params = {
      includeArea
    };
    return Promise.all(regionIds.map(id => this.for(id).details(params))).then(regions => new PagedList(regions));
  }

  create(region
  /*: Object*/
  )
  /*: Promise<Region>*/
  {
    const path = `/regions`;
    const req = new this.client.Request(path, region, createFields);
    req.serialize = serialize;
    req.parse = Region.fromJsonSimple;
    return this.client.post(req);
  } // TODO: Eradicate these legacy calls in dependent repos, then remove them here


  searchAdmin(...args)
  /*: Promise<PagedList<Region>>*/
  {
    return this.legacy.searchAdmin(...args);
  }

  persist(region
  /*: Region*/
  )
  /*: Promise<Region>*/
  {
    return this.legacy.persist(region);
  }

  details(regionId
  /*: string*/
  )
  /*: Promise<Region>*/
  {
    return this.legacy.details(regionId);
  }

  detailsWithArea(regionId
  /*: string*/
  )
  /*: Promise<Region>*/
  {
    return this.legacy.detailsWithArea(regionId);
  }

}

module.exports = RegionsRepo;